import { CSSProperties, ReactNode } from "react";
import { Drawer, IconButton } from "@mui/material";
import { useStyle } from "./style";
import { Close } from "@mui/icons-material";
import { BUTTON_IDS } from "@features/dataLayer/buttonIds";

interface IParams {
    width?: CSSProperties["width"];
    anchor?: "right" | "bottom";
    isOpen: boolean;
    onClose?(): void;
    children: ReactNode;
}

export const SidePanel = (props: IParams) => {
    const { width, anchor, isOpen, onClose, children } = props;
    const { classes } = useStyle({ width, anchor });

    return (
        <Drawer
            anchor={anchor ?? "right"}
            classes={{ paper: classes.paper }}
            open={isOpen}
            slotProps={{
                backdrop: {
                    className: classes.backdrop,
                },
            }}
        >
            <IconButton
                aria-label="close-button"
                className={classes.closeButton}
                id={BUTTON_IDS.MOBILE_FLOW.DRAWER_CTA.CLOSE}
                size="large"
                onClick={onClose}
            >
                <Close />
            </IconButton>
            {children}
        </Drawer>
    );
};
